/*
 * ByLamari: Grundskript des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026).
 * Ersetzt die React-Teile des Neubaus, die überall gebraucht werden:
 *  - Kopf beim Scrollen (components/Header.tsx useKopfBeimScrollen)
 *  - Leisten als <dialog>: Menü, Suche, Warenkorb (lib/cart-drawer.ts)
 *  - Handy-Menü mit Auftritt-Animation, „Mehr anzeigen“, Ringe aufklappen (components/MobileNav.tsx)
 *  - Suche mit Vorschlägen (components/SearchDrawer.tsx), über /search/suggest.json
 *  - Produktkarte: Wechselbild beim Darüberfahren, Wischen am Handy (components/ProductCard.tsx)
 *  - Cookie-Einstellungen im Footer öffnen den eigenen Banner (snippets/bylamari-consent)
 * Warenkorb: assets/bl-warenkorb.js.
 */
(function () {
  var BL = (window.BL = window.BL || {});

  /* ── Leisten ─────────────────────────────────────────────────────────── */
  function dialog(id) {
    var d = document.getElementById(id);
    return d && d.tagName === 'DIALOG' ? d : null;
  }
  BL.oeffne = function (id) {
    var d = dialog(id);
    if (d && !d.open) d.showModal();
  };
  BL.schliesse = function (id) {
    var d = dialog(id);
    if (d && d.open) d.close();
  };
  document.addEventListener('click', function (e) {
    var t = e.target;
    var auf = t.closest && t.closest('[data-bl-oeffne]');
    if (auf) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var id = auf.getAttribute('data-bl-oeffne');
      if (!dialog(id)) return;
      e.preventDefault();
      BL.oeffne(id);
      return;
    }
    var zu = t.closest && t.closest('[data-bl-schliesse]');
    if (zu) {
      var d = zu.closest('dialog');
      if (d) d.close();
      return;
    }
    // Klick neben die Leiste (auf den abgedunkelten Rand) schließt sie
    if (t.tagName === 'DIALOG' && t.open) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) t.close();
    }
  });

  /* ── Kopf beim Scrollen ───────────────────────────────────────────────── */
  var WEG_AB = 100;
  (function () {
    var el = document.querySelector('[data-bl-kopf]');
    if (!el) return;
    var oben = el.querySelector('.bl-header__oben');
    var last = window.scrollY, ticking = false;
    function setze(z) {
      if (z === 'kopf') el.style.setProperty('--bl-kopf-oben', (oben ? oben.offsetHeight : 0) + 'px');
      el.classList.toggle('is-weg', z === 'weg');
      el.classList.toggle('is-kopf', z === 'kopf');
    }
    function pruefe() {
      ticking = false;
      var y = window.scrollY, delta = y - last;
      last = y;
      if (y <= WEG_AB) return setze('oben');
      if (delta === 0) return;
      if (document.querySelector('dialog[open]') || el.contains(document.activeElement)) return setze('kopf');
      setze(delta > 0 ? 'weg' : 'kopf');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(pruefe);
    }, { passive: true });
    el.addEventListener('focusin', function () { if (window.scrollY > WEG_AB) setze('kopf'); });
  })();

  /* ── Handy-Menü: Auftritt ─────────────────────────────────────────────── */
  var SCHRITT = 40, KNAPPER = 4, MIN = 14, MAX = 280, DAUER = 900;
  var taktStart = 0, phasenTimer = 0;
  var menue = dialog('mobile-nav-drawer');
  function staffeln(liste) {
    taktStart = performance.now();
    if (menue) menue.style.setProperty('--bl-menue-spaet', '0ms');
    var n = 0, verz = 0;
    Array.prototype.forEach.call(liste, function (el) {
      if (el.getClientRects().length === 0) return;
      el.style.setProperty('--verz', verz + 'ms');
      el.querySelectorAll('.bl-menue__foto').forEach(function (f) { f.style.removeProperty('--foto-spaet'); });
      verz = Math.min(MAX, verz + Math.max(MIN, SCHRITT - KNAPPER * n++));
    });
  }
  function seitTakt() { return Math.round(performance.now() - taktStart) + 'ms'; }
  function fotoGeladen(img) {
    if (img.hasAttribute('data-geladen')) return;
    if (menue && menue.open && img.parentElement) img.parentElement.style.setProperty('--foto-spaet', seitTakt());
    img.setAttribute('data-geladen', '');
  }
  if (menue) {
    menue.querySelectorAll('img[data-bl-menue-foto]').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) fotoGeladen(img);
      else img.addEventListener('load', function () { fotoGeladen(img); }, { once: true });
    });
    var namen = { 'bl-menue-auf': 1, 'bl-menue-foto': 1, 'bl-menue-zahl': 1 };
    menue.addEventListener('toggle', function () {
      if (!menue.open) return;
      menue.setAttribute('data-auftritt', '');
      clearTimeout(phasenTimer);
      phasenTimer = setTimeout(function () { menue.removeAttribute('data-auftritt'); }, DAUER);
      staffeln(menue.querySelectorAll('.bl-menue__auf'));
      if (menue.getAnimations) {
        menue.getAnimations({ subtree: true }).forEach(function (a) {
          if (a.animationName && namen[a.animationName]) { a.currentTime = 0; a.play(); }
        });
      }
    });
    menue.addEventListener('click', function (e) {
      var mehr = e.target.closest('[data-bl-menue-mehr]');
      if (mehr) {
        var liste = document.getElementById(mehr.getAttribute('aria-controls'));
        var offen = mehr.getAttribute('aria-expanded') !== 'true';
        mehr.setAttribute('aria-expanded', String(offen));
        mehr.querySelector('span').textContent = offen ? 'Weniger anzeigen' : 'Mehr anzeigen';
        var neue = liste.querySelectorAll(':scope > .bl-menue__eintrag--mehr');
        neue.forEach(function (li) { li.hidden = !offen; });
        if (offen) staffeln(neue);
        return;
      }
      var auf = e.target.closest('[data-bl-menue-auf]');
      if (auf) {
        var unter = document.getElementById(auf.getAttribute('aria-controls'));
        var jetzt = auf.getAttribute('aria-expanded') !== 'true';
        auf.setAttribute('aria-expanded', String(jetzt));
        unter.hidden = !jetzt;
        if (jetzt) staffeln(unter.querySelectorAll(':scope > li'));
        return;
      }
      if (e.target.closest('a[href]')) menue.close();
    });
  }

  /* ── Suche ────────────────────────────────────────────────────────────── */
  (function () {
    var leiste = dialog('search-drawer');
    if (!leiste) return;
    var feld = leiste.querySelector('[data-bl-suche-feld]');
    var inhalt = leiste.querySelector('[data-bl-suche-inhalt]');
    var status = leiste.querySelector('[data-bl-suche-status]');
    var alle = leiste.querySelector('[data-bl-suche-alle]');
    var start = inhalt.innerHTML;
    var timer = 0, nr = 0;
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function geld(v) {
      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
      if (!isFinite(n)) return '';
      return n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }
    function suchUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product'; }
    function zeige(q) {
      var mein = ++nr;
      var alt = inhalt.querySelector('ul');
      if (alt) alt.classList.add('opacity-60');
      else inhalt.innerHTML = '<p class="text-on-surface-secondary text-sm">Suche läuft …</p>';
      leiste.querySelector('#search-drawer-results').setAttribute('aria-busy', 'true');
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
        .then(function (r) { if (!r.ok) throw new Error('suche'); return r.json(); })
        .then(function (d) {
          if (mein !== nr) return;
          var p = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!p.length) {
            inhalt.innerHTML = '<p class="text-on-surface-secondary text-sm">Keine Ergebnisse für „' + esc(q) + '“</p>';
            status.textContent = 'Keine Vorschläge für „' + q + '“';
          } else {
            inhalt.innerHTML = '<ul role="list" class="grid gap-1">' + p.map(function (x) {
              var bild = x.featured_image && x.featured_image.url ? x.featured_image.url : x.image;
              var img = bild
                ? '<img src="' + esc(bild) + (bild.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="' + esc((x.featured_image && x.featured_image.alt) || '') + '" width="48" height="48" class="bg-surface-secondary size-12 shrink-0 rounded object-cover" loading="lazy">'
                : '<span class="bg-surface-secondary size-12 shrink-0 rounded" aria-hidden="true"></span>';
              return '<li><a href="' + esc(x.url) + '" class="hover:bg-surface-secondary focus-visible:outline-accent flex items-center gap-3 rounded p-2 no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 motion-safe:transition-colors">' + img +
                '<span class="flex min-w-0 flex-col"><span class="type-body-sm text-on-surface line-clamp-2 font-medium">' + esc(x.title) + '</span>' +
                (x.price != null ? '<span class="text-on-surface-secondary text-sm">' + geld(x.price) + '</span>' : '') + '</span></a></li>';
            }).join('') + '</ul>';
            status.textContent = p.length + ' ' + (p.length === 1 ? 'Vorschlag' : 'Vorschläge') + ' für „' + q + '“';
          }
        })
        .catch(function () {
          if (mein !== nr) return;
          inhalt.innerHTML = '<p role="alert" class="text-critical text-sm">Vorschläge sind gerade nicht verfügbar. Nutze bitte die Suchseite.</p>';
        })
        .then(function () { leiste.querySelector('#search-drawer-results').setAttribute('aria-busy', 'false'); });
    }
    feld.addEventListener('input', function () {
      var q = feld.value.trim();
      clearTimeout(timer);
      if (!q) { nr++; inhalt.innerHTML = start; status.textContent = ''; alle.hidden = true; return; }
      alle.hidden = false;
      alle.href = suchUrl(q);
      alle.textContent = 'Alle Ergebnisse für „' + q + '“ ansehen';
      timer = setTimeout(function () { zeige(q); }, 200);
    });
    feld.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      leiste.close();
    });
    leiste.addEventListener('close', function () {
      feld.value = ''; nr++; inhalt.innerHTML = start; status.textContent = ''; alle.hidden = true;
    });
    leiste.addEventListener('toggle', function () { if (leiste.open) setTimeout(function () { feld.focus(); }, 30); });
    leiste.addEventListener('click', function (e) { if (e.target.closest('a[href]')) leiste.close(); });
  })();

  /* ── Produktkarte: Wechselbild und Wischen ───────────────────────────── */
  function wechselbild(karte) {
    if (karte.querySelector('.bl-product-card__hover')) return;
    var src = karte.getAttribute('data-bl-hover-src');
    if (!src) return;
    var img = document.createElement('img');
    img.className = 'bl-product-card__hover';
    img.src = src;
    img.srcset = karte.getAttribute('data-bl-hover-srcset') || '';
    img.sizes = karte.getAttribute('data-bl-sizes') || '';
    img.alt = '';
    img.width = 480; img.height = 480;
    img.decoding = 'async';
    var media = karte.querySelector('.bl-product-card__media');
    var erstes = media && media.querySelector('img');
    if (erstes) erstes.after(img); else if (media) media.prepend(img);
  }
  BL.wechselbild = wechselbild;
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var k = e.target.closest && e.target.closest('.bl-product-card[data-bl-hover-src]');
    if (k) wechselbild(k);
  });
  var wisch = null, geswischt = false, wischKarte = null;
  document.addEventListener('touchstart', function (e) {
    var k = e.target.closest && e.target.closest('.bl-product-card[data-bl-wischen]');
    wischKarte = k; geswischt = false; wisch = null;
    if (!k) return;
    var p = e.touches[0], f = k.querySelector('.bl-product-card__media').getBoundingClientRect();
    if (p && p.clientY >= f.top && p.clientY <= f.bottom) { wisch = { x: p.clientX, y: p.clientY }; wechselbild(k); }
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!wisch || geswischt || !wischKarte) return;
    var p = e.touches[0]; if (!p) return;
    var dx = p.clientX - wisch.x, dy = p.clientY - wisch.y;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      wischKarte.classList.toggle('is-alt', dx < 0);
      geswischt = true;
    }
  }, { passive: true });
  document.addEventListener('click', function (e) {
    if (!geswischt || !wischKarte || !wischKarte.contains(e.target)) return;
    e.preventDefault(); e.stopPropagation(); geswischt = false;
  }, true);

  /* ── Cookie-Einstellungen ─────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-bl-cookie-einstellungen]')) return;
    if (window.blConsent && window.blConsent.open) window.blConsent.open();
  });
})();